const AdministartorRights = [
  {
    page: "Dashboard",
    rights: { View: true, Update: false, Delete: false },
  },
  {
    page: "Statistic",
    rights: { View: false, Update: false, Delete: false },
  },
  {
    page: "Competitions",
    rights: { View: true, Update: true, Delete: false },
  },
  { page: "Dream home", rights: { View: true, Update: true, Delete: false } },
  {
    page: "Lifestyle Prizes",
    rights: { View: true, Update: true, Delete: false },
  },
  {
    page: "Fixed Odds",
    rights: { View: true, Update: true, Delete: false },
  },
  {
    page: "User management",
    rights: { View: true, Update: true, Delete: true },
  },
  {
    page: "Staff management",
    rights: { View: true, Update: true, Delete: false },
  },
  {
    page: "General",
    rights: { View: true, Update: true, Delete: true },
  },
  {
    page: "Winners",
    rights: { View: true, Update: true, Delete: true },
  },
  {
    page: "Referrals",
    rights: { View: true, Update: true, Delete: true },
  },
  {
    page: "Reports",
    rights: { View: true, Update: true, Delete: true },
  }
];

const SuperAdministartorRights = [
  {
    page: "Dashboard",
    rights: { View: true, Update: true, Delete: true },
  },
  {
    page: "Statistic",
    rights: { View: true, Update: true, Delete: true },
  },
  {
    page: "Competitions",
    rights: { View: true, Update: true, Delete: true },
  },
  { page: "Dream home", rights: { View: true, Update: true, Delete: true } },
  {
    page: "Lifestyle Prizes",
    rights: { View: true, Update: true, Delete: true },
  },
  {
    page: "Fixed Odds",
    rights: { View: true, Update: true, Delete: true },
  },
  {
    page: "User management",
    rights: { View: true, Update: true, Delete: true },
  },
  {
    page: "Staff management",
    rights: { View: true, Update: true, Delete: true },
  },
  {
    page: "General",
    rights: { View: true, Update: true, Delete: true },
  },
  {
    page: "Winners",
    rights: { View: true, Update: true, Delete: true },
  },
  {
    page: "Referrals",
    rights: { View: true, Update: true, Delete: true },
  },
  {
    page: "Reports",
    rights: { View: true, Update: true, Delete: true },
  }
];

const ModeratorRights = [
  {
    page: "Dashboard",
    rights: { View: true, Update: false, Delete: false },
  },
  {
    page: "Statistic",
    rights: { View: false, Update: false, Delete: false },
  },
  {
    page: "Competitions",
    rights: { View: true, Update: false, Delete: false },
  },
  { page: "Dream home", rights: { View: true, Update: true, Delete: false } },
  {
    page: "Lifestyle Prizes",
    rights: { View: true, Update: true, Delete: false },
  },
  {
    page: "Fixed Odds",
    rights: { View: true, Update: true, Delete: false },
  },
  {
    page: "User management",
    rights: { View: true, Update: true, Delete: false },
  },
  {
    page: "Staff management",
    rights: { View: true, Update: false, Delete: false },
  },
  {
    page: "General",
    rights: { View: true, Update: false, Delete: false },
  },
  {
    page: "Winners",
    rights: { View: true, Update: true, Delete: false },
  },
  {
    page: "Referrals",
    rights: { View: true, Update: true, Delete: false },
  },
  {
    page: "Reports",
    rights: { View: true, Update: false, Delete: false },
  }
];

export default{
    AdministartorRights,
    SuperAdministartorRights,
    ModeratorRights
}